import { Maybe, Rule } from 'types/dt-graphql-apollo-v2';

export const isRuleDisabled = (rule: Rule) => rule.tags?.includes('_disabled');

export function getDisabledRulesCount(rules: Maybe<Rule>[]) {
  return rules.filter((rule) => rule && isRuleDisabled(rule)).length;
}
